import { Box, Stack } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"
import { Repeat } from "lib/@components/repeat"
import { ResponseCard } from "./response-card"

const EMPTY_RESPONSES = []

/**
 * One share link's section on the internal reviewer's regime "Responses" tab: a heading with the
 * link's name and a card per recipient response. The link's `requestedFields` are bound once for the
 * whole group so every `ResponseCard` (and its rows) can pair each field with the response's value
 * without prop-drilling. Mirrors `share-link-comment-summary-group.js`.
 *
 * @param {object} props
 * @param {{ shareLinkId: string, shareLinkName?: string, requestedFields?: Array, responses?: Array }} props.group
 */
export function ResponsesGroup({ group }) {
    if (!group) return null

    return (
        <Box data-cy={`share-link-responses-group-${group.shareLinkId}`}>
            <Bound requestedFields={group.requestedFields}>
                <Stack spacing={1.5}>
                    <Repeat list={getResponses()} pass="response" keyFn={responseKey} item={<ResponseCard />} />
                </Stack>
            </Bound>
        </Box>
    )

    function getResponses() {
        return Array.isArray(group.responses) ? group.responses : EMPTY_RESPONSES
    }
}

function responseKey(response, index) {
    return response?._id ?? response?.createdBy ?? index
}
